export default __webpack_public_path__ + "static/media/phone-concepts.8c1cafa7.webp";